import React, { useState, useEffect } from 'react';
import DspxModal from '../../../../../common/DspxModal/DspxModal';
import { Form, message, Modal } from 'antd';
import { useAddClientDocuments } from '../../../../../../requests/addDocuments';
import { TenantAttachmentItem } from '../TenantAttachmentItem/TenantAttachmentItem';
import useAddField from '../../../../../../../../hooks/useAddField';

const TenantAttachmentsNamesNode = ({
  form,
  clientId,
  type,
  visible,
  onCancel,
  ...props
}) => {
  const {
    keys: tenantAttachmentItems,
    add: addTenantAttachmentItem,
    remove: removeTenantAttachmentItem,
  } = useAddField({
    form,
    name: 'tenantAttachmentItem',
    initialNumOfFields: 1,
  });

  const { getFieldDecorator, setFieldsValue, resetFields } = form;
  const subTypes = type?.subTypes || [];
  const attachments = type?.attachments || [];

  const [documents, setDocuments] = useState([]);
  const [usedSubTypes, setUsedSubTypes] = useState(new Set());

  useEffect(() => {
    if (attachments.length) {
      const sortedSubTypes = [...subTypes].sort(
        (a, b) => b.name.length - a.name.length
      );

      const attachSubTypes = attachments
        .map((attach) => {
          const match = sortedSubTypes.find(({ name }) =>
            attach.name.includes(name)
          );
          return match?.name;
        })
        .filter(Boolean);

      setUsedSubTypes(new Set(attachSubTypes));
    }
  }, [attachments, subTypes]);

  const handleCancel = () => {
    if (documents.length) {
      Modal.confirm({
        title: 'Внимание!!!',
        content: 'Документ не был загружен и будет удален',
        okText: 'Да',
        cancelText: 'Нет',
        onOk: () => {
          setDocuments([]);
          resetFields();
          onCancel();
        },
        okType: 'danger',
      });
    } else {
      resetFields();
      onCancel();
    }
  };

  const { addClientDocuments, loading: isAddClientDocumentsLoading } =
    useAddClientDocuments();

  const handleSubmit = () => {
    try {
      form.validateFields((err, _values) => {
        if (err) return;

        if (!documents.length) {
          message.error('Выберите документ');
          return;
        }

        addClientDocuments({
          clientId,
          documentType: type.id,
          files: documents,
        }).then(() => {
          setDocuments([]);
          resetFields();
          onCancel();
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <DspxModal
      onCancel={handleCancel}
      visible={visible}
      title={`Документы по типу «${type?.name || 'Неизвестный тип'}»`}
      onOk={handleSubmit}
      okText="Добавить"
      confirmLoading={isAddClientDocumentsLoading}
      destroyOnClose
      {...props}
    >
      {tenantAttachmentItems.map((key, index) => (
        <TenantAttachmentItem
          addTenantAttachmentItem={addTenantAttachmentItem}
          setUsedSubTypes={setUsedSubTypes}
          setFieldsValue={setFieldsValue}
          usedSubTypes={usedSubTypes}
          setDocuments={setDocuments}
          key={`${key}-${index}`}
          fieldKey={key}
          index={index}
          getFieldDecorator={getFieldDecorator}
          subTypes={subTypes}
          onRemoveTenantAttachmentField={removeTenantAttachmentItem}
          isLastElem={tenantAttachmentItems.length - 1 === index}
        />
      ))}
    </DspxModal>
  );
};

export const TenantAttachmentsNamesModal = Form.create({
  name: 'tenant_attachments_names',
})(TenantAttachmentsNamesNode);
